import { Mathdown } from '../../../assets/mathdown'
import { ReferencesList } from '../../../assets/reference/List'
import { ArticleDraft } from '../../../firebase'
import { useMacros } from '../../../hooks/models/useMacros'
import { useReferences } from '../../../hooks/models/useReferences'
import { Designed } from '../../../types'

type Props = {
  draft: ArticleDraft
}

export const ArticleDraftDetail = ({
  draft,
  ...containerProps
}: Designed<Props>) => {
  const { macros } = useMacros(draft.ref, true)
  const { references } = useReferences(draft.ref, true)
  return (
    <div {...containerProps}>
      <div className="d-flex flex-column h-100">
        <h1 className="fs-3 flex-shrink-0 text-break">
          {draft.title || 'タイトル未設定'}
        </h1>
        <div className="mathdown-colorful flex-grow-1 overflow-y-auto">
          <hr className="my-4" />
          {macros && (
            <Mathdown
              dynamic
              mathdown={draft.body || '本文が入力されていません。'}
              macros={macros}
              references={references}
              className="text-break"
            />
          )}
          {references && references.length > 0 && (
            <>
              <h2>参考文献</h2>
              <ReferencesList references={references} amazonBookImage link />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
